'use strict';

const Enum = require('./enum');

/**
 * Routes for setting/using timers
 *
 * The first segment of the route should always be 'timer'
 *
 * @enum
 * @readonly
 */
const Timers = Object.create(Enum, {
  DOORBELL_CALL_EXPIRED: { value: 'timer.doorbell.call.expired', enumerable: true },
  DOORBELL_OFFLINE: { value: 'timer.doorbell.offline', enumerable: true },
  DOORBELL_DVR_UPLOAD: { value: 'timer.doorbell.dvr.upload', enumerable: true },
  AIRBNB_GUEST_EMAIL_REMINDER: { value: 'timer.partners.airbnb.guest.email.reminder' },
  SUBSCRIPTION_TRIAL_EXPIRATION_REMINDER: { value: 'timer.subscription.trial.expiration.reminder', enumerable: true },
  SUBSCRIPTION_TRIAL_EXPIRATION_WARNING: { value: 'timer.subscription.trial.expiration.warning', enumerable: true },
  DOORBELL_VIDEO_ENCODING_FALLBACK: { value: 'timer.doorbell.video.encoding.fallback', enumerable: true },
  VIDEO_24H: { value: 'timer.video.24hourfreeavr', enumerable: true },
  LOCK_BATTERY_NOTIFICATIONS: { value: 'timer.lock.battery.notifications', enumerable: true },
  KEYPAD_BATTERY_NOTIFICATIONS: { value: 'timer.keypad.battery.notifications', enumerable: true },
  RETRY_FAILED_PIN: { value: 'timer.retry.failed.pins', enumerable: true },
  BRIDGE_TIME_OFFLINE: { value: 'timer.bridge.time.offline', enumerable: true },
  REMOVE_EXPIRED_TEMP_PINS: { value: 'timer.remove.expired.temporary.pins', enumerable: true },
  DELETE_DOORBELL_IMAGES: { value: 'timer.delete.doorbell.images', enumerable: true },
  IFTTT_DELETE_TEST_DATA: { value: 'timer.ifttt.delete.test.data', enumerable: true },
  MANUFACTURING_UPLOAD_TIMEOUT: { value: 'timer.manufacturing.upload.timeout', enumerable: true },
  MANUFACTURING_IMPORT_RETRY: { value: 'timer.manufacturing.import.retry', enumerable: true },
  ORCHESTRA_ACCESS_EXPIRATION: { value: 'timer.orchestra.access.expiration', enumerable: true },
  ORCHESTRA_ACCESS_EXPIRATION_WARNING: { value: 'timer.orchestra.access.warning', enumerable: true },
  ORCHESTRA_CREDENTIAL_EXPIRATION: { value: 'timer.orchestra.credential.expiration', enumerable: true },
  REMOVE_PARTNERS_EXPIRED_TEMP_PIN: { value: 'timer.remove.partners.expired.temporary.pin', enumerable: true },
  DELETE_SMS_LOGS: { value: 'timer.sms.delete', enumerable: true },
});

/**
 * Routes for notifications sent by Event Processor in response to a timer expiration
 *
 * The first segment of the route should indicate where the message is processed
 *
 * @enum
 * @readonly
 */
const TimerNotifications = Object.create(Enum, {
  DOORBELL_CALL_EXPIRED: { value: 'rest.doorbell.call.expired', enumerable: true },
  DOORBELL_OFFLINE: { value: 'mars.doorbell.offline', enumerable: true },
  DOORBELL_DVR_UPLOAD: { value: 'mars.dvr.upload.timeout', enumerable: true },
  DOORBELL_VIDEO_ENCODING_FALLBACK: { value: 'm3u.doorbell.video.encoding.fallback', enumerable: true },
  RETRY_FAILED_PIN: { value: 'pin.processor.retry.failed.pins', enumerable: true },
  REMOVE_EXPIRED_TEMP_PINS: { value: 'pin.processor.remove.expired.temporary.pins', enumerable: true },
  ORCHESTRA_ACCESS_EXPIRATION: { value: 'lcp.orchestra.access.expiration', enumerable: true },
  ORCHESTRA_ACCESS_EXPIRATION_WARNING: { value: 'lcp.orchestra.access.warning', enumerable: true },
  ORCHESTRA_CREDENTIAL_EXPIRATION: { value: 'lcp.orchestra.credential.expiration', enumerable: true },
  REMOVE_PARTNERS_EXPIRED_TEMP_PIN: { value: 'pin.processor.remove.partners.expired.temporary.pin', enumerable: true },
  DELETE_SMS_LOGS: { value: 'notification.sms.delete', enumerable: true },
});

exports.Timers = Timers;
exports.TimerNotifications = TimerNotifications;
